export enum SearchIndex {
  PURCHASE_ORDER = 'private_purchase_order_items__v1',
  PURCHASE_REQUISITION = 'private_purchase_requisition_items__v1',
  CONTRACT = 'private_contract_items__v1',
  SOURCING_PROJECT = 'private_sourcing_project_lot_items__v1',
}

export interface SearchIndexId {
  id: string;
}
export interface SearchIndexDates {
  createdAtTimestamp: number;
  updatedAtTimestamp: number;
}
export interface SearchIndexSourceRefence {
  sourceReference: string;
  sourceSystem: string;
  isPrimary: boolean;
}
